import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/tailwind.css";
// import moment from "moment";
import Vuelidate from "vuelidate";

import { Button, Form, Input, Select, Steps, Radio, Checkbox, InputNumber, Modal, Tabs, notification, DatePicker,Table,Tag } from "ant-design-vue";

import YanProgress from "yan-progress";
import Notifications from "vue-notification";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
Vue.use(Loading);
Vue.use(Notifications);

import VueSuggestion from 'vue-suggestion'
Vue.use(VueSuggestion)

Vue.config.productionTip = false;
// Vue.prototype.moment = moment;

Vue.use(Vuelidate);
Vue.use(require('vue-moment'));

Vue.use(Button);
Vue.use(Form);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Steps);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(Modal);
Vue.use(notification);
Vue.use(Tabs);
Vue.use(DatePicker);
Vue.use(YanProgress);
Vue.use(Table);
Vue.use(Tag);

//Quill Editor
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
Vue.use(VueQuillEditor, /* { default global options } */)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
